var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c(
        "b-modal",
        {
          ref: "modal",
          attrs: {
            id: "modal",
            title: "Direct Message: Eliza - Support Technician",
            size: "lg",
            scrollable: "",
            "hide-footer": "",
          },
        },
        [
          _c("div", { staticClass: "row mb-3" }, [
            _c("div", { staticClass: "col" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.message,
                    expression: "message",
                  },
                ],
                ref: "fldMessage",
                staticClass: "form-control",
                attrs: {
                  disabled: _vm.waiting,
                  type: "text",
                  placeholder: "Type your response here...",
                },
                domProps: { value: _vm.message },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.chat.apply(null, arguments)
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.message = $event.target.value
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _vm.waiting
                  ? _c("b-alert", { attrs: { show: "", variant: "warning" } }, [
                      _vm._v("Eliza is typing a message..."),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.reverseLog, function (logEntry) {
                  return _c(
                    "b-alert",
                    {
                      key: logEntry.index,
                      attrs: {
                        show: "",
                        variant: logEntry.bot ? "info" : "success",
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            (logEntry.bot ? "Eliza: " : _vm.fullName + ": ") +
                              logEntry.message
                          ) +
                          "\n        "
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }